<template>
  <div class="jin-details">
    <JinPc :details="details" />
    <JinM :details="details" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import JinPc from './page/pc'
import JinM from './page/mobile'
export default {
  components: {
    JinPc,
    JinM
  },
  data() {
    return {
      details: null
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    ...mapActions('position', ['GET_DETAILS']),
    async getDetails() {
      this.GET_DETAILS(this.$route.query.id)
    }
  }
}
</script>
